<nz-header *ngIf="isLoggedIn">
  <ul nz-menu nzTheme="dark" nzMode="horizontal" class="header-menu">
    <li nz-menu-item class="nz-menu-item " routerLink="/customers" routerLinkActive='active'>
      <fa-icon nz-tooltip nzTooltipTitle="Home" nzTooltipPlacement="bottom" [icon]="faLandmark"></fa-icon>
    </li>
    <li nz-menu-item class="nz-menu-item tab-icon" routerLink="/status" routerLinkActive='active' *ngIf="isLoggedIn">
      <fa-icon nz-tooltip nzTooltipTitle="Site Monitoring" nzTooltipPlacement="bottom"
        [icon]="faHourglassEndIcon"></fa-icon>
      <!-- <div class="tab-text">Status</div> -->
    </li>
    <li nz-menu-item class="nz-menu-item tab-icon" routerLink="/logs" routerLinkActive='active' *ngIf="isLoggedIn">
      <fa-icon nz-tooltip nzTooltipTitle="Audit Logs" nzTooltipPlacement="bottom" [icon]="faFileShieldIcon"></fa-icon>
      <!-- <div class="tab-text audit">Audit Logs</div> -->
    </li>
    <li nz-menu-item class="nz-menu-item tab-icon" routerLink="/vendors" routerLinkActive='active' *ngIf="isLoggedIn">
      <fa-icon nz-tooltip nzTooltipTitle="Vendors" nzTooltipPlacement="bottom" [icon]="faShopLogoIcon"></fa-icon>
      <!-- <div class="tab-text audit">Audit Logs</div> -->
    </li>
    <li nz-menu-item class="nz-menu-item " (click)="logout()" routerLinkActive='active' *ngIf="isLoggedIn">
      <fa-icon nz-tooltip nzTooltipTitle="Logout" nzTooltipPlacement="bottom" [icon]="faPowerOffIcon"></fa-icon>
    </li>
  </ul>
</nz-header>

<nz-content class='router'>
  <router-outlet></router-outlet>
</nz-content>
<!-- https://gitlab.com/vikash25/practice-nodejs-angular.git -->
<!-- routerLink="/logout" routerLinkActive='active' -->